
import * as ipxRuntime$ZG_kX8iXg7NdFbzsiL3cXcGG_qiE6NsPSN56lvXuaGw from '/home/runner/work/flagman/flagman/apps/frontstore/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.1_ioredis@5.6.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "localhost",
    "api.flagmantc.ru"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "avif",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$ZG_kX8iXg7NdFbzsiL3cXcGG_qiE6NsPSN56lvXuaGw, defaults: {"maxAge":31536000} }
}
        